import type { ReactNode } from "react";
import { cx } from "./util";

export type BadgeTone =
  | "amber" // utility / neutral status
  | "host" // racetrack red, one per room
  | "ready" // signal orange, forward state
  | "carbon"; // halftone slab, quiet metadata

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
  /** Pop in when the badge first appears. */
  animate?: boolean;
}

export function Badge({ tone = "amber", children, className, animate = false }: BadgeProps) {
  return (
    <span
      className={cx(
        "badge",
        "t-label",
        tone === "host" && "badge-host",
        tone === "ready" && "badge-ready",
        tone === "carbon" && "slab",
        animate && "bd-pop",
        className,
      )}
    >
      {children}
    </span>
  );
}
